import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '../../../variables';
import { PAtom } from '../../../atoms/text-atoms/text-atoms';

const NoResultsFound = ({ className }) => {
  return (
    <div className={className}>
      <PAtom>
        No results found. Please update your search term or filters.
      </PAtom>
    </div>
  );
};

// === NoResultsFound CSS ===
const StyledNoResultsFound = styled(NoResultsFound)`
  margin: ${vars.spacingM} 0;
`;

export default StyledNoResultsFound;
